import { IconButton, Rating, TextField } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import { MdDelete } from "react-icons/md";

function SingleReview({ rating, message, fullname, onChange, onDelete }) {
  const [data, setData] = useState({ rating, message, fullname });
  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    onChange(data);
  }, [data]);

  return (
    <div className="flex flex-col w-full border-2 border-dotted border-gray-400 rounded-md relative ">
      <div className="absolute right-0 bottom-0 translate-x-3 translate-y-3 bg-primary rounded-full z-10">
        <IconButton size="small" sx={{ opacity: 1 }} onClick={onDelete}>
          <MdDelete color="white" />
        </IconButton>
      </div>
      <Rating
        value={data.rating ?? 0}
        name="rating"
        size="large"
        className="p-2 bg-customGray"
        onChange={handleChange}
      />
      <TextField
        label="User Fullname"
        variant="filled"
        fullWidth
        value={data.fullname}
        onChange={handleChange}
        name="fullname"
      />
      <TextField
        label="Message"
        variant="filled"
        fullWidth
        value={data.message}
        onChange={handleChange}
        name="message"
      />
    </div>
  );
}

export default SingleReview;
